import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services';
import { PAGE_ROUTES } from '@shared/core-data';

export const initializationGuard: CanActivateFn = (): boolean => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.accessToken) {
    router.navigate(['/' + PAGE_ROUTES.LOADING]).then();
    authService.login();

    return false;
  }
  return true;
};
